import React from 'react';
import './Privacy.css';

const Privacy: React.FC = () => {
    return (
        <div className="privacy-page">
            <div className="privacy-container">
                <h1>Privacy Policy</h1>
                <p>Last Updated: {new Date().toLocaleDateString()}</p>

                <section className="privacy-section">
                    <h2>Introduction</h2>
                    <p>
                        Welcome to SolveSmartHome. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>The Data We Collect</h2>
                    <p>
                        We do not require user registration. We collect minimal data via standard server logs and cookies to improve site performance and show relevant advertisements.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Affiliate Disclosure</h2>
                    <p>
                        SolveSmartHome participates in various affiliate marketing programs. This means we may get paid commission on products purchased through our links to retailer sites. This does not affect our recommendations.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Cookies</h2>
                    <p>
                        We use cookies to enhance your experience. You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Privacy;
